// Remember to also update imgproxy "maxSrcResolution"! (https://github.com/imgproxy/imgproxy/issues/96)
const MAX_FILE_SIZE_MB = 30;

export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
